import { Paper, Stack, Switch, Table, Text } from '@mantine/core';
import { ErrorAlert } from '@/components/error-alert';
import { useWidgetToggle } from './use-widget-toggle';

export const CONTACT_CENTER_FEATURE_ID = 'contact-center';

export function FeaturesPanel({
  organizationId,
  enabledWidgetIds,
}: {
  organizationId: string;
  enabledWidgetIds: Set<string>;
}) {
  const { error, pendingWidgetId, setEnabled } = useWidgetToggle(organizationId);

  return (
    <Stack gap="md">
      <Text size="sm" c="dimmed">
        Platform features that can be enabled for this organization.
      </Text>
      <ErrorAlert message={error} />
      <Paper p={0} radius="md" withBorder style={{ overflow: 'hidden' }}>
        <Table highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Feature</Table.Th>
              <Table.Th w={100}>Enabled</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Td>
                <Stack gap={2}>
                  <Text fw={500}>Contact Center</Text>
                  <Text size="xs" c="dimmed">
                    Agent softphone, call queues, skills-based routing, and real-time monitoring
                  </Text>
                </Stack>
              </Table.Td>
              <Table.Td>
                <Switch
                  checked={enabledWidgetIds.has(CONTACT_CENTER_FEATURE_ID)}
                  disabled={pendingWidgetId === CONTACT_CENTER_FEATURE_ID}
                  onChange={(e) => void setEnabled(CONTACT_CENTER_FEATURE_ID, e.currentTarget.checked)}
                />
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </Paper>
    </Stack>
  );
}
